module.exports = __webpack_public_path__ + "static/the-color-purple-a0ac713504549937c61e2270359937ac.jpg";